/**
 * Custom Ant Design Theme Configuration
 * Based on Carelli brand colors
 */

const theme = {
  token: {
    // Primary colors
    colorPrimary: "#e62c2d",
    
    // Background colors
    colorBgBase: "#ffffff",
    colorBgContainer: "#ffffff",
    colorBgElevated: "#ffffff",
    colorBgLayout: "#ffffff",
    
    // Text colors
    colorText: "#212121",
    colorTextSecondary: "#212121",
    colorTextTertiary: "#212121",
    colorTextQuaternary: "#bcbec0",
    
    // Border colors
    colorBorder: "#efefef",
    colorBorderSecondary: "#bcbec0",
    
    // Success/Error/Warning/Info (using quality colors where appropriate)
    colorSuccess: "rgb(122, 197, 90)", // quality-color
    colorInfo: "rgb(80, 131, 193)", // premium-color
    colorWarning: "rgb(196, 166, 55)", // luxury-color
    colorError: "#e62c2d", // primary-color for errors
    
    // Dark background
    colorBgSpotlight: "#212121",
    
    // Font
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    
    // Border radius
    borderRadius: 4,
    
    // Custom quality colors (accessible via theme.useToken() or useTheme hook)
    // These are custom tokens that can be accessed in components
    colorQuality: "rgb(122, 197, 90)",
    colorQualityPlus: "rgb(82, 136, 115)",
    colorPremium: "rgb(80, 131, 193)",
    colorLuxury: "rgb(196, 166, 55)",
    colorRoyal: "rgb(130, 49, 65)",
    
    // Additional brand colors (custom tokens)
    colorLightGrey: "#bcbec0",
    colorLightGreyTwo: "#efefef",
    colorDarkBg: "#212121",
    colorHeader: "#212121",
    colorDimmedText: "#212121",
    colorBtnText: "#ffffff",
    colorFooterText: "#ffffff",
    colorPrimaryHover: "#d41e1f",
    colorPrimaryActive: "#c01a1b",
  },
  
  components: {
    // Button customization
    Button: {
      primaryColor: "#ffffff",
      colorPrimary: "#e62c2d",
      colorPrimaryHover: "#d41e1f",
      colorPrimaryActive: "#c01a1b",
      borderRadius: 4,
    },
    
    // Tag customization (for status badges)
    Tag: {
      borderRadius: 4,
    },
    
    // Card customization
    Card: {
      borderRadius: 8,
      colorBorderSecondary: "#efefef",
    },
    
    // Input customization
    Input: {
      borderRadius: 4,
      colorBorder: "#efefef",
      colorBorderHover: "#bcbec0",
    },
    
    // Select customization
    Select: {
      borderRadius: 4,
      colorBorder: "#efefef",
    },
    
    // Table customization
    Table: {
      colorBorderSecondary: "#efefef",
    },
    
    // Layout customization
    Layout: {
      bodyBg: "#ffffff",
      headerBg: "#212121",
      headerColor: "#ffffff",
      footerBg: "#212121",
      footerColor: "#ffffff",
      siderBg: "#212121",
    },
    
    // Menu customization
    Menu: {
      itemActiveBg: "#efefef",
      itemHoverBg: "#efefef",
      itemSelectedBg: "#e62c2d",
      itemSelectedColor: "#ffffff",
      // Dark menu customization
      darkItemBg: "#212121",
      darkSubMenuItemBg: "#212121",
      darkItemSelectedBg: "rgba(230, 44, 45, 0.3)",
    },
  },
  
  // Algorithm for dark mode support (optional, can be enabled later)
  algorithm: undefined, // Can be set to theme.darkAlgorithm if needed
};

export default theme;

/**
 * Quality color mappings for use in components
 * These correspond to the quality tiers in the system
 */
export const qualityColors = {
  quality: "rgb(122, 197, 90)",
  qualityPlus: "rgb(82, 136, 115)",
  premium: "rgb(80, 131, 193)",
  luxury: "rgb(196, 166, 55)",
  royal: "rgb(130, 49, 65)",
};

/**
 * Helper function to get quality color by name
 * @param {string} qualityName - Name of the quality tier
 * @returns {string} Color value
 */
export const getQualityColor = (qualityName) => {
  const normalizedName = qualityName?.toLowerCase().replace(/\s+/g, "");
  return qualityColors[normalizedName] || qualityColors.quality;
};

